export default __webpack_public_path__ + "static/media/footerbg.d94a458c.png";